module.exports = __webpack_public_path__ + "img/Niro_halo.8808b0fa.png";